export const EMPTY_FORM = {
  companyLegalName: "",
  tradeName: "",
  cnpj: "",
  foundationDate: "",
  stateRegistration: "",
  businessSegment: "",
  primaryCnae: "",
  fullAddress: "",
  cityState: "",
  zipCode: "",
  street: "",
  neighborhood: "",
  city: "",
  state: "",
  addressNumber: "",
  phone: "",
  corporateEmail: "",
  website: "",
  socialMedia: "",
  clientNotes: "",
};

export const APPROVAL_STATUS = {
  APPROVED: "APPROVED",
  PENDING: "PENDING",
  REJECTED: "REJECTED",
};

export const APPROVAL_STATUS_META = {
  [APPROVAL_STATUS.APPROVED]: {
    label: "Aprovado",
    className: "approved",
  },
  [APPROVAL_STATUS.PENDING]: {
    label: "Análise cadastral",
    className: "pending",
  },
  [APPROVAL_STATUS.REJECTED]: {
    label: "Reprovado",
    className: "rejected",
  },
};

export const normalizeApprovalStatus = (value) => {
  const normalized = String(value || "")
    .trim()
    .toUpperCase();

  return APPROVAL_STATUS_META[normalized] ? normalized : APPROVAL_STATUS.PENDING;
};

export const getApprovalStatusMeta = (value) =>
  APPROVAL_STATUS_META[normalizeApprovalStatus(value)] || APPROVAL_STATUS_META.PENDING;

export const formatCnpj = (value = "") => {
  const digits = String(value || "").replace(/\D/g, "").slice(0, 14);

  if (!digits) return "";
  if (digits.length <= 2) return digits;
  if (digits.length <= 5) return `${digits.slice(0, 2)}.${digits.slice(2)}`;
  if (digits.length <= 8) return `${digits.slice(0, 2)}.${digits.slice(2, 5)}.${digits.slice(5)}`;
  if (digits.length <= 12) {
    return `${digits.slice(0, 2)}.${digits.slice(2, 5)}.${digits.slice(5, 8)}/${digits.slice(8)}`;
  }

  return `${digits.slice(0, 2)}.${digits.slice(2, 5)}.${digits.slice(5, 8)}/${digits.slice(8, 12)}-${digits.slice(12)}`;
};

export const formatZipCode = (value = "") => {
  const digits = String(value || "").replace(/\D/g, "").slice(0, 8);
  if (digits.length <= 5) return digits;
  return `${digits.slice(0, 5)}-${digits.slice(5)}`;
};

export const formatPhone = (value = "") => {
  const digits = String(value || "").replace(/\D/g, "").slice(0, 11);

  if (digits.length <= 2) return digits ? `(${digits}` : "";
  if (digits.length <= 6) return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
  if (digits.length <= 10) {
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`;
  }

  return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
};

export const normalizeDateForInput = (value) => {
  if (!value) return "";
  return String(value).slice(0, 10);
};

const parseStoredAddress = (fullAddress = "") => {
  const [streetAndNumber = "", neighborhood = ""] = String(fullAddress).split(/\s+-\s+/, 2);
  const separatorIndex = streetAndNumber.lastIndexOf(",");

  if (separatorIndex < 0) {
    return { street: streetAndNumber.trim(), addressNumber: "", neighborhood: neighborhood.trim() };
  }

  return {
    street: streetAndNumber.slice(0, separatorIndex).trim(),
    addressNumber: streetAndNumber.slice(separatorIndex + 1).trim(),
    neighborhood: neighborhood.trim(),
  };
};

export const normalizeSearchText = (value = "") =>
  String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();

export const sortByUpdatedAtDesc = (items = []) =>
  [...items].sort((a, b) => {
    const aTime = new Date(a.updatedAt || a.createdAt || 0).getTime();
    const bTime = new Date(b.updatedAt || b.createdAt || 0).getTime();
    return bTime - aTime;
  });

export const mapClientToForm = (client = {}) => {
  const parsedAddress = parseStoredAddress(client.fullAddress || "");
  const [city = "", state = ""] = String(client.cityState || "").split("/", 2);

  return ({
  companyLegalName: client.companyLegalName || "",
  tradeName: client.tradeName || "",
  cnpj: formatCnpj(client.cnpj || ""),
  foundationDate: normalizeDateForInput(client.foundationDate),
  stateRegistration: client.stateRegistration || "",
  businessSegment: client.businessSegment || "",
  primaryCnae: client.primaryCnae || "",
  fullAddress: client.fullAddress || "",
  cityState: client.cityState || "",
  zipCode: formatZipCode(client.zipCode || ""),
  street: parsedAddress.street,
  neighborhood: parsedAddress.neighborhood,
  city: city.trim(),
  state: state.trim(),
  addressNumber: parsedAddress.addressNumber,
  phone: formatPhone(client.phone || ""),
  corporateEmail: client.corporateEmail || "",
  website: client.website || "",
  socialMedia: client.socialMedia || "",
  clientNotes: client.clientNotes || "",
  });
};

export const shortenText = (value = "", maxLen = 90) => {
  const text = String(value || "").trim();
  if (!text) return "";
  if (text.length <= maxLen) return text;
  return `${text.slice(0, maxLen - 3)}...`;
};
